import DIApi from './_diApi';

class AssetAPI extends DIApi {
  controllerName = 'Assets';
}

export default new AssetAPI();
